import React from 'react';
import {
  NativeSyntheticEvent,
  TextInputFocusEventData,
} from 'react-native/types';

import { isInputSafe } from 'utils/inputValidation';

import YbCoreInput from '@yubi/yb-core-input';
import { useStyles } from '@yubi/yb-style-provider';

interface InputViewProps {
  id?: string;
  label?: string;
  initialValue: string;
  size?: 's' | 'm' | 'l';
  onBlur?: (
    e: NativeSyntheticEvent<TextInputFocusEventData>,
    value: string | undefined
  ) => void;
  onKeyPress?: (e: KeyboardEvent) => void;
  onChangeText: (text: string | number | undefined) => void;
  placeholder?: string;
  isNumeric?: boolean;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  maxLength?: number;
  isRequired?: boolean;
}

const InputView: React.FC<InputViewProps> = ({
  id = 'input',
  initialValue = '',
  size = 'm',
  label,
  onChangeText,
  onKeyPress,
  onBlur,
  disabled,
  placeholder,
  isNumeric,
  error,
  touched,
  maxLength,
  isRequired,
}) => {
  const { styleConnector } = useStyles();

  const handleChangeText = (text: string | number | undefined) => {
    if (typeof text === 'string' && !isInputSafe(text)) return;
    onChangeText(text);
  };

  return (
    <YbCoreInput
      id={id}
      label={label}
      value={initialValue}
      onChangeText={handleChangeText}
      styleConnector={styleConnector}
      size={size}
      onKeyPress={onKeyPress}
      onBlur={onBlur}
      placeholder={placeholder}
      isNumeric={isNumeric}
      error={error}
      touched={touched}
      disabled={disabled}
      maxLength={maxLength}
      isRequired={isRequired}
    />
  );
};

export default InputView;
